import { render, staticRenderFns } from "./PostNav.vue?vue&type=template&id=22cf62e6&scoped=true"
import script from "./PostNav.vue?vue&type=script&lang=ts"
export * from "./PostNav.vue?vue&type=script&lang=ts"
import style0 from "./PostNav.vue?vue&type=style&index=0&id=22cf62e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf62e6",
  null
  
)

export default component.exports